module.exports = {
    CHAIN_ID:56,
    CONTRACT_ADDRESS:"0x9858226544ABBD2688070585ebC0B0565De73558",
    RPC:"https://bsc-dataseed1.defibit.io/",
    BASE_URL:"http://localhost:3001/",
    IPFS_URL:"https://ipfs.infura.io/ipfs/"
}

